import axios from '@/axios';

const RESOURCE_NAME = '/admin/needs';

export default {
    getNeeds(data) {
        return axios.post(`${RESOURCE_NAME}/get-needs`, data)
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getFoundStartups(id, listType, data) {
        return axios.post(`${RESOURCE_NAME}/get-found-startups`, data, {
            params: {
                id,
                listType,
            }
        })
    },

    setPublicStatus(ids, status) {
        return axios.post(`${RESOURCE_NAME}/set-public-status`, {ids: ids, status: status});
    },

    deleteStartup(id, startupId) {
        return axios.post(`${RESOURCE_NAME}/delete-startup?id=${id}`, {startupId});
    },

    getEcosystems(data) {
        return axios.post(`${RESOURCE_NAME}/get-ecosystems`, data)
    },

    getEcosystemNeeds(ecosystemId, listType, data) {
        return axios.post(`${RESOURCE_NAME}/get-ecosystem-needs`, data, {
            params: {
                ecosystemId,
                listType
            }
        })
    },

    export(gridData, ids) {
        return axios.post(`${RESOURCE_NAME}/export`, {...gridData, ids});
    },
}
